import { Toaster } from 'sonner';

export const ToastToaster = () => (
  <>
    <Toaster
      id="toast-toaster"
      position="bottom-left"
      swipeDirections={['top', 'left', 'right', 'bottom']}
      offset={48}
    />

    <Toaster
      id="toast-no-swipe"
      position="bottom-left"
      swipeDirections={[]}
      offset={48}
    />
  </>
);
